import React from 'react';

import './button-icon.styles.scss';

// color: primary, error
// disabled: Boolean

export const ButtonIcon = ({type, color = 'primary', size = 'md', disabled, clickHandler, children, additionalClasses = ''}) => {
    const buttonProps = {
        type: type || 'button',
        className: `btn-icon btn-icon--${size} btn-icon--${color} ${additionalClasses}`,
        disabled
    };

    return (
        <button {...buttonProps}  onClick={clickHandler}>
            {children}
        </button>
    )
};

export default React.memo(ButtonIcon);